<template>
  <div class="flex flex-col gap-5">
    <UButton 
      color="primary" 
      variant="outline" 
      block 
      label="Use Current Location" 
      size="lg" 
      :ui="{ variant: { outline: 'ring-2' }, rounded: 'rounded-xl' }" 
      :class="{ 'opacity-50 pointer-events-none': isLoading || isRequesting }" @click="callLocationPermission" 
      :loading="isLoading" 
    />
    <div class="text-red-500" v-if="error">{{ error }}</div>
  </div>
</template>


<script setup lang="ts">
import { GoogleAnalytics } from '~/google_analytics/events'
import { EventParameter } from '~/google_analytics/events.enum'

const { getCurrentLocation, isLoading, emitter } = useLocationFinder()
const location = useLocation()
const checkout = useCheckout()
const error = ref<string | null>(null)
const isRequesting = ref(false)

const emits = defineEmits<{
  (e: 'success'): void
  (e: 'error', message: string): void
}>()

const onSuccess = (coords: { latitude: number; longitude: number }) => {
  if (!isRequesting.value) return

  isRequesting.value = false
  error.value = null

  location.setCoords(coords.latitude, coords.longitude)

  GoogleAnalytics.cta({
    [EventParameter.CTA_NAME]: 'use current location',
  })

  emits('success')
}

const onError = (message: string) => {
  if (!isRequesting.value) return

  isRequesting.value = false
  error.value = message
  emits('error', message)
}

onMounted(() => {
  emitter.on('success', onSuccess as any)
  emitter.on('error', onError as any)
})

onUnmounted(() => {
  emitter.off('success', onSuccess as any)
  emitter.off('error', onError as any)
})

const callLocationPermission = async () => {
  if (isLoading.value || isRequesting.value) return

  isRequesting.value = true
  error.value = null
  checkout.delivery_address = null
  getCurrentLocation()
}
</script>
